/* /nat-type-test — what the measurements MEAN for the person: the network the test actually ran on,
   the console verdict, the to-do list ranked by what blocks play first, the line grade over the worst
   path, the asks for the provider letter, and the comparison with what the console itself shows.
   Pure (no DOM, no timers): the page renders it, tests/js/nat-probe.test.mjs proves every branch.
   Needs window.NatProbe (public/js/nat-probe.js) for the raw NAT→console mapping and line limits.
   Why each rule exists — docs/why/nat-type-test.md, «Советы» (QA round 04.11.2026). */
(function (w) {
    'use strict';
    if (w.NatAdvice) return;
    var P = function () { return w.NatProbe; };

    // severity: 4 = nothing works until this is fixed, 3 = blocks play with many people, 2 = felt in
    // play, 1 = worth doing, 0 = information
    var BLOCKER_NETS = { browser: 1, blocked: 1, firewall: 1, offline: 1 };
    var VPN_CLASSES = { hosting: 1, relay: 1, tor: 1 };

    /* Which network did the test actually measure? Decides whether router advice applies at all. */
    function netOf(res, ctx) {
        var n = res.n || {}, sv = res.sv || {};
        if (BLOCKER_NETS[n.udp]) return n.udp;
        // the address STUN saw belongs to a VPN / relay / Tor: we measured THEIR NAT, not the router's
        if (sv.udpClass && VPN_CLASSES[sv.udpClass]) return 'vpn';
        if (ctx && ctx.conn === 'cellular') return 'cellular';
        // only the site went through a relay or a proxy; WebRTC went straight — the measurement stands
        if (sv.differs && sv.httpClass && VPN_CLASSES[sv.httpClass]) return 'relay_http';
        return 'normal';
    }

    function lineOf(res) {
        var NP = P(), qs = (res.q || []).filter(Boolean), ok = qs.filter(function (q) { return q && q.ok; });
        var L = { attempted: qs.length > 0, paths: [], grade: 'unknown', worstRegion: null, failed: [],
                  abroad: null, bufferbloat: null, loadMissed: null, partial: !!res.stoppedLine, interrupted: (res.hiddenMs || 0) > 1000 };
        qs.forEach(function (q) { if (!q.ok) L.failed.push({ region: q.region, why: q.why || 'error' }); });
        ok.forEach(function (q) { L.paths.push({ region: q.region, grade: NP.grade(q), iss: NP.issues(q) }); });
        var wg = NP.worstGrade(ok); L.grade = wg.grade; L.worstRegion = wg.region;
        var p0 = ok[0] && ok[0].region === (qs[0] && qs[0].region) ? ok[0] : null;
        var far = qs.length > 1 && qs[1] && qs[1].ok ? qs[1] : null;
        L.primary = p0; L.far = far;
        if (p0 && far) {
            var i0 = NP.issues(p0), i1 = NP.issues(far);
            if (i1.loss >= 1 && i0.loss === 0) L.abroad = { region: far.region, lossPct: far.lossPct };
        }
        var q0 = p0 || ok[0];
        if (q0 && q0.loaded) {
            if (!q0.loadBytes || q0.loadBytes < 1e6) L.loadMissed = 'no_load';
            else if (q0.loadedSamples != null && q0.loadedSamples < 15) L.loadMissed = 'too_fast';
            else if (q0.quietP50 == null || q0.loadedP50 == null) L.loadMissed = 'no_samples';
            else {
                var d = q0.loadedP50 - q0.quietP50;
                L.loadDelta = d;
                if (d > 30) L.bufferbloat = { ms: d };
            }
        }
        return L;
    }

    function assess(res, ctx) {
        ctx = ctx || {};
        var NP = P(), n = res.n || {}, wan = ctx.wan && ctx.wan.kind || null;
        var net = netOf(res, ctx);
        var extras = {
            cgnat: wan === 'cgnat', double: wan === 'double', mismatch: wan === 'mismatch',
            vpn: net === 'vpn', cellular: net === 'cellular'
        };
        var v = NP.verdict(n, extras);
        var L = lineOf(res);
        var todos = [], add = function (key, sev, p) { todos.push({ key: key, sev: sev, p: p || {} }); };
        var m = n.mapping ? n.mapping.kind : 'unknown', f = n.filtering ? n.filtering.kind : 'unknown';

        if (BLOCKER_NETS[net]) {
            add('todo_' + (net === 'browser' ? 'browser_blocks' : net === 'blocked' ? 'udp_blocked' : net), 4);
        } else if (net === 'cellular') {
            add('todo_cellular', 4);
        } else if (net === 'vpn') {
            add('todo_vpn', 4);
        } else {
            var fixedUpstream = extras.cgnat || extras.double || extras.mismatch;
            if (m === 'interfaces') add('todo_interfaces', 3);
            if (m === 'multi') add('todo_multi', 3);
            if (extras.cgnat) add(n.ipv6 === true ? 'todo_dslite' : 'todo_cgnat', 3);
            if (extras.mismatch) add('todo_mismatch', 3);
            if (extras.double) add('todo_double', 3);
            if (m === 'dependent' && !fixedUpstream) { add('todo_upnp', 3); add('todo_ports', 2); }
            if (m === 'independent' && (f === 'address' || f === 'port') && !fixedUpstream) add('todo_upnp_xbox', 1);
            if (n.hairpin === 'no') add('todo_hairpin', 1);
            if (n.ipv6 === true && !(extras.cgnat) && v.xbox.plain !== 'open' && v.xbox.plain !== 'unknown') add('todo_ipv6_xbox', 1);
            if (m === 'unknown' || (m === 'independent' && f === 'unknown')) add('todo_retry', 1);
            if (net === 'relay_http') add('todo_relay_ok', 0);

            // the line — advice only from data that can carry it
            if (L.attempted && !L.paths.length) add('todo_line_failed', 2, { why: (L.failed[0] && L.failed[0].why) || 'error' });
            else if (L.interrupted) add('todo_line_interrupted', 2);
            else if (L.partial) add('todo_line_partial', 1);
            else if (L.paths.length) {
                var q0 = L.primary || (res.q || []).filter(function (q) { return q && q.ok; })[0];
                var i0 = NP.issues(q0);
                if (i0.loss >= 1) add('todo_loss_wifi', i0.loss >= 2 ? 3 : 2);
                if (i0.jitter >= 1 || i0.spikes >= 1) add('todo_jitter', Math.max(i0.jitter, i0.spikes) >= 2 ? 2 : 1);
                if (L.abroad) add('todo_abroad', 2, { region: L.abroad.region, lossPct: L.abroad.lossPct });
                if (L.bufferbloat) add('todo_bufferbloat', 2, { ms: L.bufferbloat.ms });
                // one path failed, the others graded the line: say which one is missing (QA M10)
                if (L.failed.length) add('todo_line_path_failed', 1, { region: L.failed[0].region, why: L.failed[0].why });
            }
        }
        // stable sort by severity, most blocking first
        todos = todos.map(function (t, i) { t._i = i; return t; })
            .sort(function (a, b) { return (b.sev - a.sev) || (a._i - b._i); })
            .map(function (t) { delete t._i; return t; });
        if (!todos.some(function (t) { return t.sev >= 1; })) todos.push({ key: 'todo_good', sev: 0, p: {} });

        return { net: net, verdict: v, line: L, todos: todos, asks: asksOf(net, n, extras, L), wan: wan };
    }

    /* What the letter to the provider asks for — by the actual issue (QA m10). null = no letter makes
       sense from this measurement (another network, a browser setting, offline). */
    function asksOf(net, n, extras, L) {
        if (net === 'browser' || net === 'offline' || net === 'cellular' || net === 'vpn') return null;
        var a = [];
        if (net === 'blocked' || net === 'firewall') a.push('isp_ask_udp');
        if (extras.cgnat || extras.mismatch) a.push(n.ipv6 === true && extras.cgnat ? 'isp_ask_dualstack' : 'isp_ask_cgnat');
        if (!L.interrupted && !L.partial && L.paths.length) {
            var NP = P(), q0 = L.primary;
            var i0 = q0 ? NP.issues(q0) : null;
            if (i0 && i0.loss >= 1) a.push('isp_ask_loss');
            else if (i0 && (i0.jitter >= 1 || i0.spikes >= 1)) a.push('isp_ask_jitter');
            if (L.abroad) a.push('isp_ask_abroad');
        }
        if (!a.length) a.push('isp_ask_info');
        return a;
    }

    /* What the console itself shows vs what the router does with this device (QA m8). Returns the
       message key; `.code` goes to telemetry. */
    var RANK = { ps5: { type1: 1, type2: 2, type3: 3, fail: 4 }, xbox: { open: 1, moderate: 2, strict: 3 } };
    function compareConsole(pick, A) {
        if (pick === 'ps5_type1') return 'cd_type1';
        if (pick === 'xbox_teredo') return 'cd_teredo';
        if (!A) return 'cd_need_run';
        if (A.net === 'cellular' || A.net === 'vpn' || A.net === 'browser' || A.net === 'offline') return 'cd_net_first';
        if (pick === 'ps5_fail') return (A.net === 'blocked' || A.net === 'firewall') ? 'cd_same_blocked' : 'cd_ps5_fail';
        var kind = pick.indexOf('ps5') === 0 ? 'ps5' : 'xbox', val = pick.slice(kind.length + 1);
        var v = A.verdict[kind] || {}, r = RANK[kind], mine = r[val], plain = r[v.plain], up = v.upnp ? r[v.upnp] : null;
        if (!plain || !mine) return 'cd_need_retry';
        var upstream = A.verdict.causes.some(function (c) { return c === 'cgnat' || c === 'double' || c === 'mismatch' || c === 'multi_exit'; });
        if (mine === plain) {
            if (up && up < plain) return 'cd_same_upnp_off';
            return upstream ? 'cd_same_provider' : 'cd_same';
        }
        if (up && mine === up) return 'cd_better';
        if (mine < Math.min(plain, up || plain)) return 'cd_better_direct';
        // the console sees worse than this device: another network or a second router in front of it —
        // and with a NAT upstream of the router UPnP is no answer (QA m7)
        if (mine > plain) return upstream ? 'cd_worse_upstream' : 'cd_worse';
        return 'cd_same';
    }

    /* The WAN address read off the router page. The state only follows a USABLE answer; anything
       else clears it, so an old "two routers" never outlives the input (QA m5). */
    var WAN_STATE = { cgnat: 1, double: 1, public: 1, mismatch: 1 };
    function wanApply(input, publicIp) {
        var r = P().classifyWan(input, publicIp);
        return { kind: r.kind, ip: r.ip || null, state: WAN_STATE[r.kind] ? r.kind : null };
    }

    w.NatAdvice = { assess: assess, netOf: netOf, lineOf: lineOf, asksOf: asksOf, compareConsole: compareConsole, wanApply: wanApply, RANK: RANK };
})(typeof window !== 'undefined' ? window : globalThis);
